export const retry = (fn, { retries, retryIntervalMs }) =>
  Promise.resolve()
    .then(() => fn())
    .catch((error) =>
      retries > 0
        ? wait(retryIntervalMs).then(() =>
            retry(fn, { retries: retries - 1, retryIntervalMs })
          )
        : Promise.reject(error)
    );

const wait = (ms = 0) =>
  new Promise((resolve) => setTimeout(resolve, ms));